<div
  class="ui-steps ui-widget ui-helper-clearfix ui-steps-readonly"
  *ngIf="steps && steps.length > 0"
  style="margin-left: -1em"
>
  <ul role="tablist">
    <li
      *ngFor="let step of steps; let i = index"
      class="ui-steps-item"
      [class.ui-state-highlight]="activeIndex == i"
      [class.ui-state-disabled]="activeIndex < i"
      [class.ui-state-completed]="activeIndex > i"
    >
      <div class="ui-menuitem-link link" (click)="gotoStep(i)">
        <span class="ui-steps-number">{{ i + 1 }}</span>
        <span class="ui-steps-title">{{ step.label }}</span>
      </div>
    </li>
  </ul>
</div>
